import Vue from 'vue'
import Router from "vue-router"
Vue.use(Router)
const routes = [], funcJs = require.context('./modules', false, /\.js$/)
funcJs.keys().forEach(fn => {
  const obj = funcJs(fn);
  (obj.default || obj).forEach(v => Object.prototype.toString.call(v) === '[object Object]' ? routes.push(v) : '')
})

// console.log('Router',Router.prototype)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({ routes })

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("authorization");
  // 白名单 不用token也可进入
  let whiteArr = ['openList','login','h5login','register','index','findpass','accountBinding','adminLogin','error']
  if (!token && whiteArr.indexOf(to.name) == -1) {
      next({ name: 'login' })
  } else {
      //权限在这里添加。
      //跳转页面前查询此用户是否有此权限
      next()
  }
})

export default router
